import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Hidden from "@material-ui/core/Hidden";
// @material-ui/icons
import Menu from "@material-ui/icons/Menu";
// core components
import AdminNavbarLinks from "./AdminNavbarLinks.jsx";
import Button from "components/CustomButtons/Button.jsx";
import headerStyle from "assets/jss/material-dashboard-react/components/headerStyle.jsx";
import { useState } from "react";
function Header({ ...props }) {
  function makeBrand() {
    console.log('propssss ',props)
    var name;
    props.routes && props.routes.map((prop, key) => {
      if (prop.layout + prop.path === props.location.pathname) {
        name = prop.name;
      }
      return null;
    });
    return name;
  }
  let userName=  sessionStorage.getItem('plugoUserMobileNo');
  const { classes, color } = props;
  const appBarClasses = classNames({
    [" " + classes[color]]: color
  });

  // Using hooks for initially setting the flag
  const [europeflag, setstate] = useState(()=>{
    if( process.env.REACT_APP_ACTIVE_REGION == "europe" )
    {
      return true
    }
    else
    {
      return false
    }
  })
  let currentNumber = sessionStorage.getItem("plugoUserMobileNo");

  
  return (
    <AppBar className={classes.appBar + appBarClasses}>
      <Toolbar className={classes.container}>
        <div className={classes.flex}>
    {europeflag ? (
      <Button color="transparent" href="#" className={classes.title}>
      {makeBrand()} 
        <span className = "text-success ml-2">{currentNumber.includes("+31") ? "NL-101": "Europe"}</span>
        <span className = "text-success ml-2">, {userName}</span>
    </Button>

    ) : (
            <Button color = "transparent" href = "#" className = {classes.title}>
        {makeBrand()} 
        </Button>

    )}
          
        </div>
        <AdminNavbarLinks />
        <Hidden mdUp implementation="css">
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={props.handleDrawerToggle}
          > 
            <Menu />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"])
};

export default withStyles(headerStyle)(Header);
